var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('video',{ref:"player",staticClass:"video-js vjs-theme-intio",class:{'vjs-fluid': _vm.fluid},attrs:{"controls":"","preload":"auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }